import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import ObtieneDatosCookies from "../obtieneDatosCookiesUsuario";
import comprueboPermisos from "../tools/comprueboPermisos.js";
const API_BASE = "https://wwwa.isepsantafe.net.ar/expedientes/ingresos";
const VeoDatos = () => {
  const Usuario = ObtieneDatosCookies();
  const tienePermisoIngresos = comprueboPermisos(
    Usuario?.funcion,
    "Veo Procesos de Ingreso"
  );
  const tienePermisoEscuelas = comprueboPermisos(
    Usuario?.funcion,
    "Escuelas"
  );
  const esDestino7 = Number(Usuario?.destino) === 7;
  const normalizarTexto = (valor = "") =>
    String(valor)
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .trim()
      .toLowerCase();
const filtrarFormulariosPorPermiso = (lista = []) => {
  // Destino 7 ve absolutamente todos.
  if (esDestino7) {
    return lista;
  }

  return lista.filter((formulario) => {
    const observacion = normalizarTexto(
      formulario?.observacion ||
      formulario?.Observacion ||
      ""
    );

    const nombre = normalizarTexto(
      formulario?.nombre ||
      formulario?.Nombre ||
      ""
    );

    const esIngreso =
      observacion.includes("ingreso") ||
      observacion.includes("inscripcion") ||

      nombre.includes("inscripcion");

    const esPerfeccionamiento =
      observacion.includes("perfeccionamiento") ||
      nombre.includes("perfeccionamiento");

    if (tienePermisoIngresos && esIngreso) {
      return true;
    }

    if (tienePermisoEscuelas && esPerfeccionamiento) {
      return true;
    }

    return false;
  });
};
  const [formularios, setFormularios] = useState([]);
  const [formularioId, setFormularioId] = useState("");
  const [formulario, setFormulario] = useState(null);
  const [loadingFormularios, setLoadingFormularios] = useState(false);
  const [loadingEstructura, setLoadingEstructura] = useState(false);
  const [loadingEstadisticas, setLoadingEstadisticas] = useState(false);
  const [camposDisponibles, setCamposDisponibles] = useState([]);
  const [camposSeleccionados, setCamposSeleccionados] = useState([]);
  const [data, setData] = useState(null);
  const [busqueda, setBusqueda] = useState("");
  const [seccionesAbiertas, setSeccionesAbiertas] = useState({});
  useEffect(() => {
    obtenerFormularios();
  }, []);
  const obtenerFormularios = async () => {
    try {
      setLoadingFormularios(true);
      const res = await axios.post(
        `${API_BASE}/obtenerFormulariosActivos`
      );
      const lista = Array.isArray(res.data) ? res.data : [];
      const listaFiltrada = filtrarFormulariosPorPermiso(lista);
      setFormularios(listaFiltrada);
      
    } catch (error) {
      console.error("Error obteniendo formularios:", error);
      setFormularios([]);
    } finally {
      setLoadingFormularios(false);
    }
  };
  const cargarEstructuraFormulario = async (id) => {
    if (!id) {
      setFormulario(null);
      setCamposDisponibles([]);
      setCamposSeleccionados([]);
      setData(null);
      return;
    }
    try {
      setLoadingEstructura(true);
      setFormulario(null);
      setCamposDisponibles([]);
      setCamposSeleccionados([]);
      setData(null);
      setBusqueda("");
      setSeccionesAbiertas({});
      const res = await axios.post(
        `${API_BASE}/formularios/${id}`
      );
      const form = res.data || {};
      setFormulario(form);
      const campos = (form.Seccions || []).flatMap((seccion) =>
        (seccion.Campos || []).map((campo) => ({
          id: campo.id,
          seccion_id: seccion.id,
          seccion: seccion.nombre || "Sin sección",
          label: campo.label || campo.clave || `Campo ${campo.id}`,
          clave: campo.clave || "",
          tipo: campo.tipo || "text",
          origen: campo.origen || "formulario",
          campo_db: campo.campo_db || null,
          visible: campo.visible,
          opciones: campo.CampoOpcions || campo.opciones || [],
        }))
      );
      const camposAnalizables = campos.filter((campo) => {
        if (!campo.id) return false;
        if (
          campo.tipo === "html_static" ||
          campo.tipo === "archivo" ||
          campo.tipo === "file"
        ) {
          return false;
        }
        return true;
      });
      setCamposDisponibles(camposAnalizables);
      console.log("FORMULARIO:", form);
      console.log("CAMPOS DISPONIBLES:", camposAnalizables);
    } catch (error) {
      console.error("Error cargando estructura del formulario:", error);
      setFormulario(null);
      setCamposDisponibles([]);
      setCamposSeleccionados([]);
      setData(null);
    } finally {
      setLoadingEstructura(false);
    }
  };
  const cambiarFormulario = (e) => {
    const id = e.target.value;
    setFormularioId(id);
    cargarEstructuraFormulario(id);
  };
  const toggleCampo = (campoId) => {
    const id = Number(campoId);
    setCamposSeleccionados((prev) => {
      if (prev.includes(id)) {
        return prev.filter((item) => item !== id);
      }
      return [...prev, id];
    });
    setData(null);
  };
  const toggleSeccionAbierta = (nombreSeccion) => {
    setSeccionesAbiertas((prev) => ({
      ...prev,
      [nombreSeccion]: !prev[nombreSeccion],
    }));
  };
  const normalizarComparacion = (valor) =>
    String(valor ?? "")
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .trim()
      .toLowerCase();
  const obtenerCampoDefinicion = (campoId) => {
    return camposDisponibles.find(
      (campo) => String(campo.id) === String(campoId)
    );
  };
  const obtenerLabelOpcion = (campoId, valor) => {
    if (valor === null || valor === undefined || valor === "") {
      return "Sin dato";
    }
    const campo = obtenerCampoDefinicion(campoId);
    const opciones = campo?.opciones || [];
    const buscarLabel = (valorSimple) => {
      const buscado = normalizarComparacion(valorSimple);
      const opcion = opciones.find((op) => {
        const candidatos = [
          op?.value,
          op?.valor,
          op?.clave,
          op?.id,
          op?.label,
          op?.nombre,
          op?.texto,
        ];
        return candidatos.some(
          (candidato) =>
            candidato !== undefined &&
            candidato !== null &&
            normalizarComparacion(candidato) === buscado
        );
      });
      return (
        opcion?.label ||
        opcion?.nombre ||
        opcion?.texto ||
        opcion?.valor ||
        opcion?.value ||
        valorSimple
      );
    };
    if (Array.isArray(valor)) {
      return valor.map(buscarLabel).join(", ");
    }
    if (typeof valor === "string") {
      try {
        const parsed = JSON.parse(valor);
        if (Array.isArray(parsed)) {
          return parsed.map(buscarLabel).join(", ");
        }
        if (
          parsed !== null &&
          typeof parsed !== "object"
        ) {
          return buscarLabel(parsed);
        }
      } catch {
        // Valor normal.
      }
    }
    return buscarLabel(valor);
  };
  const seleccionarSeccion = (seccion) => {
    const ids = camposDisponibles
      .filter((campo) => campo.seccion === seccion)
      .map((campo) => Number(campo.id));
    setCamposSeleccionados((prev) => {
      const todosSeleccionados = ids.every((id) => prev.includes(id));
      if (todosSeleccionados) {
        return prev.filter((id) => !ids.includes(id));
      }
      return [...new Set([...prev, ...ids])];
    });
    setData(null);
  };
  const seleccionarTodos = () => {
    if (camposSeleccionados.length === camposDisponibles.length) {
      setCamposSeleccionados([]);
    } else {
      setCamposSeleccionados(
        camposDisponibles.map((campo) => Number(campo.id))
      );
    }
    setData(null);
  };
  const generarEstadisticas = async () => {
    if (!formularioId) {
      alert("Seleccione un formulario.");
      return;
    }
    if (camposSeleccionados.length === 0) {
      alert("Seleccione al menos un campo.");
      return;
    }
    try {
      setLoadingEstadisticas(true);
      setData(null);
      const res = await axios.post(
        `${API_BASE}/estadisticasFormularioDinamicas`,
        {
          formulario_id: Number(formularioId),
          campos: camposSeleccionados,
        }
      );
      console.log("ESTADISTICAS DINAMICAS:", res.data);
      setData(res.data);
    } catch (error) {
      console.error("Error generando estadísticas:", error);
      alert(
        error.response?.data?.error ||
        error.response?.data?.detalle ||
        "No se pudieron generar las estadísticas."
      );
    } finally {
      setLoadingEstadisticas(false);
    }
  };
  const actualizar = async () => {
    if (!formularioId) {
      await obtenerFormularios();
      return;
    }
    await cargarEstructuraFormulario(formularioId);
  };
  const secciones = useMemo(() => {
    const mapa = {};
    camposDisponibles.forEach((campo) => {
      if (!mapa[campo.seccion]) {
        mapa[campo.seccion] = [];
      }
      mapa[campo.seccion].push(campo);
    });
    return mapa;
  }, [camposDisponibles]);
  const estadisticasFiltradas = useMemo(() => {
    const lista = data?.estadisticas || [];
    const texto = busqueda.trim().toLowerCase();
    if (!texto) return lista;
    return lista.filter((estadistica) => {
      const contenido = [
        estadistica.label,
        estadistica.clave,
        estadistica.seccion,
        estadistica.tipo,
        estadistica.origen,
        ...(estadistica.valores || []).map((item) =>
          obtenerLabelOpcion(estadistica.campo_id, item.valor)
        ),
      ]
        .join(" ")
        .toLowerCase();
      return contenido.includes(texto);
    });
  }, [data, busqueda]);
  const formatearValor = (valor) => {
    if (valor === null || valor === undefined || valor === "") {
      return "Sin dato";
    }
    if (typeof valor === "object") {
      try {
        return JSON.stringify(valor);
      } catch {
        return String(valor);
      }
    }
    return String(valor);
  };
  const formatearFecha = (valor, incluirHora = false) => {
    if (!valor) return "-";
    const fecha = new Date(valor);
    if (Number.isNaN(fecha.getTime())) {
      return String(valor);
    }
    return new Intl.DateTimeFormat("es-AR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      ...(incluirHora
        ? {
            hour: "2-digit",
            minute: "2-digit",
          }
        : {}),
    }).format(fecha);
  };
  const formatearFechaClave = (valor) => {
    if (!valor) return "-";
    const partes = String(valor).split("-");
    if (partes.length !== 3) {
      return formatearFecha(valor);
    }
    return `${partes[2]}/${partes[1]}/${partes[0]}`;
  };
  const nombreArchivoSeguro = (texto = "") => {
    return String(texto || "formulario")
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[^a-zA-Z0-9_-]+/g, "_")
      .replace(/^_+|_+$/g, "")
      .toLowerCase();
  };
  const exportarExcelCompleto = () => {
    if (!data) return;
    const workbook = XLSX.utils.book_new();
    const resumen = (data.estadisticas || []).flatMap((estadistica) =>
      (estadistica.valores || []).map((item) => ({
        Seccion: estadistica.seccion || "",
        Campo: estadistica.label || "",
        Clave: estadistica.clave || "",
        Tipo: estadistica.tipo || "",
        Origen: estadistica.origen || "",
        Valor: obtenerLabelOpcion(
          estadistica.campo_id,
          item.valor
        ),
        Cantidad: item.cantidad,
        Porcentaje: item.porcentaje,
        "Con dato": estadistica.conDato || 0,
        "Sin dato": estadistica.sinDato || 0,
        Total: estadistica.total || data.total || 0,
      }))
    );
    const wsResumen = XLSX.utils.json_to_sheet(resumen);
    XLSX.utils.book_append_sheet(
      workbook,
      wsResumen,
      "Resumen"
    );
    const definiciones = data.campos || [];
    const registros = (data.registros || []).map((registro) => {
      const fila = {
        DNI: registro.dni || "",
        Apellido: registro.apellido || "",
        Nombre: registro.nombre || "",
        "Postulacion ID": registro.postulacion_id || "",
        "Fecha inscripción": registro.createdAt
          ? formatearFecha(registro.createdAt, true)
          : "",
        "Última modificación": registro.updatedAt
          ? formatearFecha(registro.updatedAt, true)
          : "",
      };
      definiciones.forEach((campo) => {
        fila[campo.label] = obtenerLabelOpcion(
          campo.id,
          registro.campos?.[campo.id]
        );
      });
      return fila;
    });
    if (registros.length > 0) {
      const wsRegistros = XLSX.utils.json_to_sheet(registros);
      XLSX.utils.book_append_sheet(
        workbook,
        wsRegistros,
        "Registros"
      );
    }
    if (data.periodo) {
      const periodoExcel = [
        {
          Concepto: "Primera inscripción",
          Valor: data.periodo.primeraInscripcion
            ? formatearFecha(data.periodo.primeraInscripcion, true)
            : "",
        },
        {
          Concepto: "Última inscripción",
          Valor: data.periodo.ultimaInscripcion
            ? formatearFecha(data.periodo.ultimaInscripcion, true)
            : "",
        },
        {
          Concepto: "Primera modificación",
          Valor: data.periodo.primeraModificacion
            ? formatearFecha(data.periodo.primeraModificacion, true)
            : "",
        },
        {
          Concepto: "Última modificación",
          Valor: data.periodo.ultimaModificacion
            ? formatearFecha(data.periodo.ultimaModificacion, true)
            : "",
        },
        {
          Concepto: "Días con inscripciones",
          Valor: data.periodo.totalDiasConInscripciones || 0,
        },
        {
          Concepto: "Día con más inscripciones",
          Valor: data.periodo.diaMayorInscripciones
            ? `${formatearFechaClave(
                data.periodo.diaMayorInscripciones.fecha
              )} - ${data.periodo.diaMayorInscripciones.cantidad}`
            : "",
        },
      ];
      const wsPeriodo = XLSX.utils.json_to_sheet(periodoExcel);
      XLSX.utils.book_append_sheet(
        workbook,
        wsPeriodo,
        "Periodo"
      );
    }
    if ((data.inscripcionesPorDia || []).length > 0) {
      const filasInscripciones = data.inscripcionesPorDia.map((item) => ({
        Fecha: formatearFechaClave(item.fecha),
        Inscripciones: item.cantidad,
        Porcentaje: item.porcentaje,
      }));
      const wsInscripciones = XLSX.utils.json_to_sheet(
        filasInscripciones
      );
      XLSX.utils.book_append_sheet(
        workbook,
        wsInscripciones,
        "Inscripciones por dia"
      );
    }
    (data.estadisticas || []).forEach((estadistica, index) => {
      const filas = (estadistica.valores || []).map((item) => ({
        Valor: item.valor,
        Cantidad: item.cantidad,
        Porcentaje: item.porcentaje,
      }));
      if (!filas.length) return;
      const ws = XLSX.utils.json_to_sheet(filas);
      let nombreHoja = String(
        estadistica.label || `Campo ${index + 1}`
      )
        .replace(/[\\\\/?*[\\]:]/g, "")
        .substring(0, 31);
      if (!nombreHoja) {
        nombreHoja = `Campo ${index + 1}`;
      }
      const nombresExistentes = workbook.SheetNames;
      if (nombresExistentes.includes(nombreHoja)) {
        nombreHoja = `${nombreHoja.substring(0, 27)}_${index + 1}`;
      }
      XLSX.utils.book_append_sheet(
        workbook,
        ws,
        nombreHoja
      );
    });
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const nombreFormulario =
      formulario?.nombre ||
      formularios.find(
        (item) => String(item.id) === String(formularioId)
      )?.nombre ||
      `formulario_${formularioId}`;
    saveAs(
      new Blob([excelBuffer], {
        type: "application/octet-stream",
      }),
      `estadisticas_${nombreArchivoSeguro(nombreFormulario)}.xlsx`
    );
  };
  const exportarCampoExcel = (estadistica) => {
    const filas = (estadistica.valores || []).map((item) => ({
      Valor: obtenerLabelOpcion(
        estadistica.campo_id,
        item.valor
      ),
      Cantidad: item.cantidad,
      Porcentaje: item.porcentaje,
    }));
    const worksheet = XLSX.utils.json_to_sheet(filas);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(
      workbook,
      worksheet,
      "Estadistica"
    );
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    saveAs(
      new Blob([excelBuffer], {
        type: "application/octet-stream",
      }),
      `${nombreArchivoSeguro(estadistica.label)}.xlsx`
    );
  };
  const formularioNombre =
    formulario?.nombre ||
    formularios.find(
      (item) => String(item.id) === String(formularioId)
    )?.nombre ||
    "";
  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <div>
          <h1 style={styles.title}>
            Estadísticas de Inscripciones
          </h1>
          <p style={styles.subtitle}>
            Análisis dinámico de formularios FormBuilder PRO
          </p>
        </div>
        <button
          type="button"
          onClick={actualizar}
          style={styles.button}
          disabled={
            loadingFormularios ||
            loadingEstructura ||
            loadingEstadisticas
          }
        >
          Actualizar
        </button>
      </div>
      <div style={styles.panel}>
        <div style={styles.stepHeader}>
          <span style={styles.stepNumber}>1</span>
          <div>
            <h2 style={styles.stepTitle}>
              Seleccionar formulario
            </h2>
            <p style={styles.stepText}>
              Se muestran los formularios activos disponibles.
            </p>
          </div>
        </div>
        <select
          value={formularioId}
          onChange={cambiarFormulario}
          style={styles.select}
          disabled={loadingFormularios}
        >
          <option value="">
            {loadingFormularios
              ? "Cargando formularios..."
              : "Seleccione un formulario"}
          </option>
          {formularios.map((form) => (
            <option key={form.id} value={form.id}>
              {form.nombre}
              {form.escuela ? ` - ${form.escuela}` : ""}
            </option>
          ))}
        </select>
        {formulario && (
          <div style={styles.formInfo}>
            <strong>{formulario.nombre}</strong>
            {formulario.descripcion && (
              <span>{formulario.descripcion}</span>
            )}
            <div style={styles.badges}>
              {formulario.escuela && (
                <span style={styles.badge}>
                  {formulario.escuela}
                </span>
              )}
              {formulario.sede && (
                <span style={styles.badge}>
                  {formulario.sede}
                </span>
              )}
              <span style={styles.badge}>
                ID {formularioId}
              </span>
            </div>
          </div>
        )}
      </div>
      {loadingEstructura && (
        <div style={styles.loading}>
          Cargando estructura del formulario...
        </div>
      )}
      {!loadingEstructura && formularioId && formulario && (
        <div style={styles.panel}>
          <div style={styles.stepHeader}>
            <span style={styles.stepNumber}>2</span>
            <div>
              <h2 style={styles.stepTitle}>
                Seleccionar datos a analizar
              </h2>
              <p style={styles.stepText}>
                Los campos se obtienen directamente de FormBuilder PRO.
              </p>
            </div>
          </div>
          <div style={styles.selectionToolbar}>
            <div>
              <strong>
                {camposSeleccionados.length}
              </strong>{" "}
              de {camposDisponibles.length} campos seleccionados
            </div>
            <button
              type="button"
              onClick={seleccionarTodos}
              style={styles.secondaryButton}
            >
              {camposSeleccionados.length === camposDisponibles.length &&
              camposDisponibles.length > 0
                ? "Quitar todos"
                : "Seleccionar todos"}
            </button>
          </div>
          {Object.entries(secciones).map(
            ([nombreSeccion, campos]) => {
              const idsSeccion = campos.map((campo) =>
                Number(campo.id)
              );
              const todosSeleccionados = idsSeccion.every(
                (id) => camposSeleccionados.includes(id)
              );
              return (
                <div
                  key={nombreSeccion}
                  style={styles.sectionBox}
                >
                  <div style={styles.sectionHeader}>
                    <button
                      type="button"
                      onClick={() =>
                        toggleSeccionAbierta(nombreSeccion)
                      }
                      style={styles.accordionButton}
                    >
                      <span style={styles.accordionArrow}>
                        {seccionesAbiertas[nombreSeccion] ? "▼" : "▶"}
                      </span>
                      <span style={styles.accordionText}>
                        <strong style={styles.sectionTitle}>
                          {nombreSeccion}
                        </strong>
                        <span style={styles.sectionCount}>
                          {campos.length} campos ·{" "}
                          {
                            idsSeccion.filter((id) =>
                              camposSeleccionados.includes(id)
                            ).length
                          } seleccionados
                        </span>
                      </span>
                    </button>
                    <button
                      type="button"
                      onClick={() =>
                        seleccionarSeccion(nombreSeccion)
                      }
                      style={styles.smallButton}
                    >
                      {todosSeleccionados
                        ? "Quitar sección"
                        : "Seleccionar sección"}
                    </button>
                  </div>
                  {seccionesAbiertas[nombreSeccion] && (
                    <div style={styles.fieldsGrid}>
                      {campos.map((campo) => {
                        const seleccionado =
                          camposSeleccionados.includes(
                            Number(campo.id)
                          );
                        return (
                          <label
                            key={campo.id}
                            style={{
                              ...styles.fieldCard,
                              ...(seleccionado
                                ? styles.fieldCardSelected
                                : {}),
                            }}
                          >
                            <input
                              type="checkbox"
                              checked={seleccionado}
                              onChange={() =>
                                toggleCampo(campo.id)
                              }
                              style={styles.checkbox}
                            />
                            <div style={styles.fieldContent}>
                              <strong style={styles.fieldLabel}>
                                {campo.label}
                              </strong>
                              <div style={styles.fieldMeta}>
                                <span>{campo.tipo}</span>
                                <span>
                                  {campo.origen === "persona"
                                    ? `Persona${
                                        campo.campo_db
                                          ? ` · ${campo.campo_db}`
                                          : ""
                                      }`
                                    : "Formulario"}
                                </span>
                              </div>
                            </div>
                          </label>
                        );
                      })}
                    </div>
                  )}
                </div>
              );
            }
          )}
          {!camposDisponibles.length && (
            <div style={styles.empty}>
              Este formulario no tiene campos analizables.
            </div>
          )}
          <div style={styles.generateArea}>
            <button
              type="button"
              onClick={generarEstadisticas}
              style={styles.generateButton}
              disabled={
                loadingEstadisticas ||
                camposSeleccionados.length === 0
              }
            >
              {loadingEstadisticas
                ? "Generando estadísticas..."
                : "Generar estadísticas"}
            </button>
          </div>
        </div>
      )}
      {loadingEstadisticas && (
        <div style={styles.loading}>
          Analizando postulaciones enviadas...
        </div>
      )}
      {!loadingEstadisticas && data && (
        <>
          <div style={styles.panel}>
            <div style={styles.resultHeader}>
              <div>
                <span style={styles.resultEyebrow}>
                  RESULTADO
                </span>
                <h2 style={styles.resultTitle}>
                  {formularioNombre}
                </h2>
              </div>
              <button
                type="button"
                onClick={exportarExcelCompleto}
                style={styles.excelButton}
              >
                Exportar Excel completo
              </button>
            </div>
            <div style={styles.cards}>
              <Card
                titulo="Total inscriptos"
                valor={data.total || 0}
                destacado
              />
              <Card
                titulo="Campos analizados"
                valor={(data.estadisticas || []).length}
              />
              <Card
                titulo="Registros"
                valor={(data.registros || []).length}
              />
            </div>
            {data.periodo && (
              <div style={styles.periodPanel}>
                <div style={styles.periodHeader}>
                  <div>
                    <span style={styles.resultEyebrow}>
                      PERÍODO DE INSCRIPCIONES
                    </span>
                    <h3 style={styles.periodTitle}>
                      Fechas de las postulaciones enviadas
                    </h3>
                  </div>
                </div>
                <div style={styles.cardsSmall}>
                  <MiniCard
                    titulo="Primera inscripción"
                    valor={formatearFecha(
                      data.periodo.primeraInscripcion,
                      true
                    )}
                  />
                  <MiniCard
                    titulo="Última inscripción"
                    valor={formatearFecha(
                      data.periodo.ultimaInscripcion,
                      true
                    )}
                  />
                  <MiniCard
                    titulo="Días con inscripciones"
                    valor={data.periodo.totalDiasConInscripciones || 0}
                  />
                  <MiniCard
                    titulo="Día con más inscripciones"
                    valor={
                      data.periodo.diaMayorInscripciones
                        ? `${formatearFechaClave(
                            data.periodo.diaMayorInscripciones.fecha
                          )} · ${
                            data.periodo.diaMayorInscripciones.cantidad
                          }`
                        : "-"
                    }
                  />
                </div>
                <GraficoEvolucionInscripciones
                  datos={data.inscripcionesPorDia || []}
                />
                <GraficoEvolucionHoraria
                  registros={data.registros || []}
                />
                {(data.inscripcionesPorDia || []).length > 0 && (
                  <div style={styles.tableWrapper}>
                    <table style={styles.table}>
                      <thead>
                        <tr>
                          <th style={styles.th}>Fecha</th>
                          <th style={styles.th}>Inscripciones</th>
                          <th style={styles.th}>Porcentaje</th>
                        </tr>
                      </thead>
                      <tbody>
                        {data.inscripcionesPorDia.map((item) => (
                          <tr key={item.fecha}>
                            <td style={styles.tdNombre}>
                              {formatearFechaClave(item.fecha)}
                            </td>
                            <td style={styles.tdTotal}>
                              {item.cantidad || 0}
                            </td>
                            <td style={styles.td}>
                              {Number(item.porcentaje || 0).toFixed(2)}%
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
                <div style={styles.modificationInfo}>
                  <span>
                    <strong>Primera modificación:</strong>{" "}
                    {formatearFecha(
                      data.periodo.primeraModificacion,
                      true
                    )}
                  </span>
                  <span>
                    <strong>Última modificación:</strong>{" "}
                    {formatearFecha(
                      data.periodo.ultimaModificacion,
                      true
                    )}
                  </span>
                </div>
              </div>
            )}
            <div style={styles.searchBox}>
              <input
                value={busqueda}
                onChange={(e) =>
                  setBusqueda(e.target.value)
                }
                placeholder="Buscar campo, sección o valor..."
                style={styles.input}
              />
            </div>
          </div>
          {estadisticasFiltradas.map((estadistica) => (
            <div
              key={estadistica.campo_id}
              style={styles.tableContainer}
            >
              <div style={styles.tableTitleRow}>
                <div>
                  <h2 style={styles.sectionTitle}>
                    {estadistica.label}
                  </h2>
                  <div style={styles.tableMeta}>
                    <span>
                      Sección: {estadistica.seccion || "-"}
                    </span>
                    <span>
                      Tipo: {estadistica.tipo || "-"}
                    </span>
                    <span>
                      Origen: {estadistica.origen || "-"}
                    </span>
                    {estadistica.clave && (
                      <span>
                        Clave: {estadistica.clave}
                      </span>
                    )}
                    {estadistica.campo_db && (
                      <span>
                        Campo DB: {estadistica.campo_db}
                      </span>
                    )}
                  </div>
                </div>
                <button
                  type="button"
                  onClick={() =>
                    exportarCampoExcel(estadistica)
                  }
                  style={styles.smallButton}
                >
                  Excel
                </button>
              </div>
              <div style={styles.cardsSmall}>
                <MiniCard
                  titulo="Con dato"
                  valor={estadistica.conDato || 0}
                />
                <MiniCard
                  titulo="Sin dato"
                  valor={estadistica.sinDato || 0}
                />
                <MiniCard
                  titulo="Valores distintos"
                  valor={(estadistica.valores || []).length}
                />
              </div>
              <div style={styles.tableWrapper}>
                <table style={styles.table}>
                  <thead>
                    <tr>
                      <th style={styles.th}>
                        Valor
                      </th>
                      <th style={styles.th}>
                        Cantidad
                      </th>
                      <th style={styles.th}>
                        Porcentaje
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {(estadistica.valores || []).map(
                      (item, index) => (
                        <tr key={`${item.valor}-${index}`}>
                          <td style={styles.tdNombre}>
                            {obtenerLabelOpcion(
                              estadistica.campo_id,
                              item.valor
                            )}
                          </td>
                          <td style={styles.tdTotal}>
                            {item.cantidad || 0}
                          </td>
                          <td style={styles.td}>
                            {Number(
                              item.porcentaje || 0
                            ).toFixed(2)}
                            %
                          </td>
                        </tr>
                      )
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          ))}
          {!estadisticasFiltradas.length && (
            <div style={styles.empty}>
              No hay estadísticas que coincidan con la búsqueda.
            </div>
          )}
        </>
      )}
    </div>
  );
};
const GraficoEvolucionInscripciones = ({ datos = [] }) => {
  if (!datos.length) return null;
  const ancho = 1000;
  const alto = 300;
  const paddingIzq = 55;
  const paddingDer = 25;
  const paddingSup = 25;
  const paddingInf = 55;
  const anchoGrafico = ancho - paddingIzq - paddingDer;
  const altoGrafico = alto - paddingSup - paddingInf;
  const maxCantidad = Math.max(
    1,
    ...datos.map((item) => Number(item.cantidad || 0))
  );
  let acumulado = 0;
  const puntos = datos.map((item, index) => {
    acumulado += Number(item.cantidad || 0);
    const x =
      datos.length === 1
        ? paddingIzq + anchoGrafico / 2
        : paddingIzq +
          (index / (datos.length - 1)) * anchoGrafico;
    const y =
      paddingSup +
      altoGrafico -
      (Number(item.cantidad || 0) / maxCantidad) * altoGrafico;
    return {
      ...item,
      x,
      y,
      acumulado,
    };
  });
  const linea = puntos
    .map((punto) => `${punto.x},${punto.y}`)
    .join(" ");
  const total = puntos[puntos.length - 1]?.acumulado || 0;
  const promedio =
    datos.length > 0
      ? (total / datos.length).toFixed(1)
      : 0;
  const mayor = puntos.reduce(
    (actual, item) =>
      !actual || Number(item.cantidad) > Number(actual.cantidad)
        ? item
        : actual,
    null
  );
  const saltoEtiqueta = Math.max(
    1,
    Math.ceil(datos.length / 8)
  );
  return (
    <div style={styles.evolutionPanel}>
      <div style={styles.evolutionHeader}>
        <div>
          <span style={styles.resultEyebrow}>
            EVOLUCIÓN
          </span>
          <h3 style={styles.periodTitle}>
            Evolución diaria de inscripciones
          </h3>
          <p style={styles.evolutionText}>
            Cantidad de postulaciones creadas por día.
          </p>
        </div>
      </div>
      <div style={styles.evolutionCards}>
        <MiniCard
          titulo="Total del período"
          valor={total}
        />
        <MiniCard
          titulo="Promedio diario"
          valor={promedio}
        />
        <MiniCard
          titulo="Máximo diario"
          valor={mayor?.cantidad || 0}
        />
        <MiniCard
          titulo="Fecha pico"
          valor={
            mayor?.fecha
              ? formatearFechaClaveGlobal(mayor.fecha)
              : "-"
          }
        />
      </div>
      <div style={styles.chartScroll}>
        <div style={styles.chartInner}>
          <svg
            viewBox={`0 0 ${ancho} ${alto}`}
            style={styles.chartSvg}
            role="img"
            aria-label="Gráfico de evolución diaria de inscripciones"
          >
            {[0, 0.25, 0.5, 0.75, 1].map((nivel) => {
              const y =
                paddingSup +
                altoGrafico -
                nivel * altoGrafico;
              const valor = Math.round(
                maxCantidad * nivel
              );
              return (
                <g key={nivel}>
                  <line
                    x1={paddingIzq}
                    y1={y}
                    x2={ancho - paddingDer}
                    y2={y}
                    stroke="#e5e7eb"
                    strokeWidth="1"
                  />
                  <text
                    x={paddingIzq - 10}
                    y={y + 4}
                    textAnchor="end"
                    fontSize="11"
                    fill="#6b7280"
                  >
                    {valor}
                  </text>
                </g>
              );
            })}
            <line
              x1={paddingIzq}
              y1={paddingSup}
              x2={paddingIzq}
              y2={alto - paddingInf}
              stroke="#9ca3af"
              strokeWidth="1"
            />
            <line
              x1={paddingIzq}
              y1={alto - paddingInf}
              x2={ancho - paddingDer}
              y2={alto - paddingInf}
              stroke="#9ca3af"
              strokeWidth="1"
            />
            <polyline
              points={linea}
              fill="none"
              stroke="#2563eb"
              strokeWidth="3"
              strokeLinejoin="round"
              strokeLinecap="round"
            />
            {puntos.map((punto, index) => (
              <g key={`${punto.fecha}-${index}`}>
                <circle
                  cx={punto.x}
                  cy={punto.y}
                  r="5"
                  fill="#ffffff"
                  stroke="#2563eb"
                  strokeWidth="3"
                >
                  <title>
                    {`${formatearFechaClaveGlobal(
                      punto.fecha
                    )}: ${punto.cantidad} inscripciones`}
                  </title>
                </circle>
                {(index % saltoEtiqueta === 0 ||
                  index === puntos.length - 1) && (
                  <text
                    x={punto.x}
                    y={alto - paddingInf + 23}
                    textAnchor="middle"
                    fontSize="10"
                    fill="#6b7280"
                  >
                    {formatearFechaClaveGlobal(
                      punto.fecha
                    ).substring(0, 5)}
                  </text>
                )}
              </g>
            ))}
          </svg>
        </div>
      </div>
      <div style={styles.evolutionLegend}>
        <span style={styles.legendDot} />
        Inscripciones por día
      </div>
    </div>
  );
};
const GraficoEvolucionHoraria = ({ registros = [] }) => {
  const datosPorHora = useMemo(() => {
    const mapa = {};
    registros.forEach((registro) => {
      if (!registro?.createdAt) return;
      const fecha = new Date(registro.createdAt);
      if (Number.isNaN(fecha.getTime())) return;
      const year = fecha.getFullYear();
      const month = String(fecha.getMonth() + 1).padStart(2, "0");
      const day = String(fecha.getDate()).padStart(2, "0");
      const hour = String(fecha.getHours()).padStart(2, "0");
      const clave = `${year}-${month}-${day} ${hour}:00`;
      mapa[clave] = (mapa[clave] || 0) + 1;
    });
    return Object.entries(mapa)
      .map(([fechaHora, cantidad]) => ({
        fechaHora,
        cantidad,
      }))
      .sort((a, b) => a.fechaHora.localeCompare(b.fechaHora));
  }, [registros]);
  if (!datosPorHora.length) return null;
  const ancho = 1000;
  const alto = 300;
  const paddingIzq = 55;
  const paddingDer = 25;
  const paddingSup = 25;
  const paddingInf = 55;
  const anchoGrafico = ancho - paddingIzq - paddingDer;
  const altoGrafico = alto - paddingSup - paddingInf;
  const maxCantidad = Math.max(
    1,
    ...datosPorHora.map((item) => Number(item.cantidad || 0))
  );
  const puntos = datosPorHora.map((item, index) => {
    const x =
      datosPorHora.length === 1
        ? paddingIzq + anchoGrafico / 2
        : paddingIzq +
          (index / (datosPorHora.length - 1)) * anchoGrafico;
    const y =
      paddingSup +
      altoGrafico -
      (Number(item.cantidad || 0) / maxCantidad) * altoGrafico;
    return {
      ...item,
      x,
      y,
    };
  });
  const linea = puntos
    .map((punto) => `${punto.x},${punto.y}`)
    .join(" ");
  const mayor = datosPorHora.reduce(
    (actual, item) =>
      !actual || Number(item.cantidad) > Number(actual.cantidad)
        ? item
        : actual,
    null
  );
  const saltoEtiqueta = Math.max(
    1,
    Math.ceil(datosPorHora.length / 10)
  );
  const formatearFechaHora = (valor) => {
    const [fecha, hora] = String(valor || "").split(" ");
    const partes = fecha.split("-");
    if (partes.length !== 3) return valor || "-";
    return `${partes[2]}/${partes[1]}/${partes[0]} ${hora || ""}`;
  };
  return (
    <div style={styles.hourlyPanel}>
      <div style={styles.hourlyHeader}>
        <div>
          <span style={styles.resultEyebrow}>
            EVOLUCIÓN POR HORARIO
          </span>
          <h3 style={styles.periodTitle}>
            Inscripciones por fecha y hora
          </h3>
          <p style={styles.evolutionText}>
            Cantidad de postulaciones creadas dentro de cada hora.
          </p>
        </div>
        <div style={styles.hourlyPeak}>
          <span style={styles.miniLabel}>
            Hora pico
          </span>
          <strong style={styles.hourlyPeakValue}>
            {mayor
              ? `${formatearFechaHora(mayor.fechaHora)} · ${mayor.cantidad}`
              : "-"}
          </strong>
        </div>
      </div>
      <div style={styles.chartScroll}>
        <div style={styles.chartInner}>
          <svg
            viewBox={`0 0 ${ancho} ${alto}`}
            style={styles.chartSvg}
            role="img"
            aria-label="Gráfico de evolución de inscripciones por horario"
          >
            {[0, 0.25, 0.5, 0.75, 1].map((nivel) => {
              const y =
                paddingSup +
                altoGrafico -
                nivel * altoGrafico;
              const valor = Math.round(
                maxCantidad * nivel
              );
              return (
                <g key={nivel}>
                  <line
                    x1={paddingIzq}
                    y1={y}
                    x2={ancho - paddingDer}
                    y2={y}
                    stroke="#e5e7eb"
                    strokeWidth="1"
                  />
                  <text
                    x={paddingIzq - 10}
                    y={y + 4}
                    textAnchor="end"
                    fontSize="11"
                    fill="#6b7280"
                  >
                    {valor}
                  </text>
                </g>
              );
            })}
            <line
              x1={paddingIzq}
              y1={paddingSup}
              x2={paddingIzq}
              y2={alto - paddingInf}
              stroke="#9ca3af"
              strokeWidth="1"
            />
            <line
              x1={paddingIzq}
              y1={alto - paddingInf}
              x2={ancho - paddingDer}
              y2={alto - paddingInf}
              stroke="#9ca3af"
              strokeWidth="1"
            />
            <polyline
              points={linea}
              fill="none"
              stroke="#7c3aed"
              strokeWidth="3"
              strokeLinejoin="round"
              strokeLinecap="round"
            />
            {puntos.map((punto, index) => (
              <g key={punto.fechaHora}>
                <circle
                  cx={punto.x}
                  cy={punto.y}
                  r="5"
                  fill="#ffffff"
                  stroke="#7c3aed"
                  strokeWidth="3"
                >
                  <title>
                    {`${formatearFechaHora(
                      punto.fechaHora
                    )}: ${punto.cantidad} inscripciones`}
                  </title>
                </circle>
                {(index % saltoEtiqueta === 0 ||
                  index === puntos.length - 1) && (
                  <text
                    x={punto.x}
                    y={alto - paddingInf + 23}
                    textAnchor="middle"
                    fontSize="9"
                    fill="#6b7280"
                  >
                    {`${punto.fechaHora.substring(
                      8,
                      10
                    )}/${punto.fechaHora.substring(
                      5,
                      7
                    )} ${punto.fechaHora.substring(
                      11,
                      16
                    )}`}
                  </text>
                )}
              </g>
            ))}
          </svg>
        </div>
      </div>
      <div style={styles.evolutionLegend}>
        <span style={styles.legendDotHourly} />
        Inscripciones agrupadas por hora
      </div>
      <div style={styles.tableWrapper}>
        <table style={styles.table}>
          <thead>
            <tr>
              <th style={styles.th}>Fecha</th>
              <th style={styles.th}>Hora</th>
              <th style={styles.th}>Inscripciones</th>
            </tr>
          </thead>
          <tbody>
            {datosPorHora.map((item) => {
              const [fecha, hora] = item.fechaHora.split(" ");
              return (
                <tr key={item.fechaHora}>
                  <td style={styles.tdNombre}>
                    {formatearFechaClaveGlobal(fecha)}
                  </td>
                  <td style={styles.td}>
                    {hora}
                  </td>
                  <td style={styles.tdTotal}>
                    {item.cantidad}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};
const formatearFechaClaveGlobal = (valor) => {
  if (!valor) return "-";
  const partes = String(valor).split("-");
  if (partes.length !== 3) {
    return String(valor);
  }
  return `${partes[2]}/${partes[1]}/${partes[0]}`;
};
const Card = ({
  titulo,
  valor,
  destacado,
}) => (
  <div
    style={{
      ...styles.card,
      ...(destacado
        ? styles.cardDestacado
        : {}),
    }}
  >
    <span style={styles.label}>
      {titulo}
    </span>
    <h2 style={styles.cardNumber}>
      {valor}
    </h2>
  </div>
);
const MiniCard = ({
  titulo,
  valor,
}) => (
  <div style={styles.miniCard}>
    <span style={styles.miniLabel}>
      {titulo}
    </span>
    <strong style={styles.miniNumber}>
      {valor}
    </strong>
  </div>
);
const styles = {
  container: {
    padding: "30px",
    fontFamily: "system-ui",
    background: "#f5f7fb",
    minHeight: "100vh",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "15px",
    marginBottom: "25px",
    flexWrap: "wrap",
  },
  title: {
    margin: 0,
    fontSize: "30px",
    color: "#111827",
  },
  subtitle: {
    margin: "6px 0 0",
    color: "#6b7280",
  },
  button: {
    border: "none",
    borderRadius: "10px",
    padding: "11px 18px",
    background: "#111827",
    color: "#ffffff",
    fontWeight: 700,
    cursor: "pointer",
  },
  panel: {
    background: "#ffffff",
    borderRadius: "16px",
    padding: "22px",
    marginBottom: "22px",
    boxShadow: "0 4px 18px rgba(0,0,0,0.06)",
  },
  stepHeader: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    marginBottom: "18px",
  },
  stepNumber: {
    width: "36px",
    height: "36px",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#111827",
    color: "#ffffff",
    fontWeight: 800,
    flexShrink: 0,
  },
  stepTitle: {
    margin: 0,
    fontSize: "20px",
    color: "#111827",
  },
  stepText: {
    margin: "3px 0 0",
    color: "#6b7280",
    fontSize: "14px",
  },
  select: {
    width: "100%",
    padding: "12px 14px",
    border: "1px solid #d1d5db",
    borderRadius: "10px",
    fontSize: "15px",
    background: "#ffffff",
  },
  formInfo: {
    marginTop: "15px",
    padding: "15px",
    borderRadius: "10px",
    background: "#f9fafb",
    display: "flex",
    flexDirection: "column",
    gap: "6px",
    color: "#374151",
  },
  badges: {
    display: "flex",
    flexWrap: "wrap",
    gap: "7px",
    marginTop: "5px",
  },
  badge: {
    display: "inline-block",
    padding: "4px 8px",
    borderRadius: "999px",
    background: "#e5e7eb",
    fontSize: "12px",
    fontWeight: 700,
  },
  loading: {
    padding: "18px",
    marginBottom: "20px",
    background: "#ffffff",
    borderRadius: "12px",
    textAlign: "center",
    fontWeight: 700,
    color: "#374151",
  },
  selectionToolbar: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "12px",
    flexWrap: "wrap",
    marginBottom: "18px",
  },
  secondaryButton: {
    border: "1px solid #d1d5db",
    borderRadius: "9px",
    padding: "9px 13px",
    background: "#ffffff",
    color: "#111827",
    fontWeight: 700,
    cursor: "pointer",
  },
  sectionBox: {
    border: "1px solid #e5e7eb",
    borderRadius: "14px",
    padding: "16px",
    marginBottom: "15px",
  },
  sectionHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "10px",
    flexWrap: "wrap",
    marginBottom: "13px",
  },
  accordionButton: {
    flex: 1,
    minWidth: "240px",
    border: "none",
    background: "transparent",
    padding: "6px 0",
    display: "flex",
    alignItems: "center",
    gap: "10px",
    textAlign: "left",
    cursor: "pointer",
  },
  accordionArrow: {
    width: "20px",
    flexShrink: 0,
    color: "#111827",
    fontSize: "14px",
    fontWeight: 800,
  },
  accordionText: {
    display: "flex",
    flexDirection: "column",
    minWidth: 0,
  },
  sectionTitle: {
    margin: 0,
    fontSize: "19px",
    color: "#111827",
  },
  sectionCount: {
    display: "block",
    marginTop: "3px",
    color: "#6b7280",
    fontSize: "13px",
  },
  smallButton: {
    border: "1px solid #d1d5db",
    borderRadius: "8px",
    padding: "7px 11px",
    background: "#ffffff",
    color: "#111827",
    fontWeight: 700,
    cursor: "pointer",
  },
  fieldsGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
    gap: "10px",
  },
  fieldCard: {
    display: "flex",
    alignItems: "flex-start",
    gap: "10px",
    padding: "13px",
    border: "1px solid #e5e7eb",
    borderRadius: "10px",
    cursor: "pointer",
    background: "#ffffff",
  },
  fieldCardSelected: {
    border: "2px solid #111827",
    background: "#f9fafb",
  },
  checkbox: {
    marginTop: "3px",
    width: "17px",
    height: "17px",
  },
  fieldContent: {
    minWidth: 0,
  },
  fieldLabel: {
    display: "block",
    color: "#111827",
    marginBottom: "5px",
  },
  fieldMeta: {
    display: "flex",
    flexDirection: "column",
    gap: "2px",
    fontSize: "12px",
    color: "#6b7280",
    wordBreak: "break-word",
  },
  generateArea: {
    display: "flex",
    justifyContent: "center",
    marginTop: "22px",
  },
  generateButton: {
    border: "none",
    borderRadius: "10px",
    padding: "13px 24px",
    background: "#111827",
    color: "#ffffff",
    fontWeight: 800,
    fontSize: "15px",
    cursor: "pointer",
  },
  resultHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "15px",
    flexWrap: "wrap",
    marginBottom: "18px",
  },
  resultEyebrow: {
    fontSize: "11px",
    fontWeight: 800,
    letterSpacing: "1.5px",
    color: "#6b7280",
  },
  resultTitle: {
    margin: "3px 0 0",
    fontSize: "23px",
    color: "#111827",
  },
  excelButton: {
    border: "none",
    borderRadius: "9px",
    padding: "10px 15px",
    background: "#166534",
    color: "#ffffff",
    fontWeight: 700,
    cursor: "pointer",
  },
  cards: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
    gap: "14px",
    marginBottom: "18px",
  },
  card: {
    background: "#ffffff",
    border: "1px solid #e5e7eb",
    borderRadius: "13px",
    padding: "17px",
  },
  cardDestacado: {
    border: "2px solid #111827",
  },
  label: {
    color: "#6b7280",
    fontSize: "13px",
    fontWeight: 700,
  },
  cardNumber: {
    margin: "7px 0 0",
    color: "#111827",
    fontSize: "28px",
  },
  evolutionPanel: {
    marginTop: "18px",
    marginBottom: "18px",
    padding: "18px",
    background: "#ffffff",
    border: "1px solid #e5e7eb",
    borderRadius: "14px",
  },
  evolutionHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    gap: "12px",
    marginBottom: "14px",
  },
  evolutionText: {
    margin: "5px 0 0",
    color: "#6b7280",
    fontSize: "13px",
  },
  evolutionCards: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))",
    gap: "10px",
    marginBottom: "18px",
  },
  chartScroll: {
    width: "100%",
    overflowX: "auto",
  },
  chartInner: {
    minWidth: "700px",
  },
  chartSvg: {
    width: "100%",
    height: "auto",
    display: "block",
  },
  evolutionLegend: {
    marginTop: "8px",
    display: "flex",
    alignItems: "center",
    gap: "7px",
    color: "#4b5563",
    fontSize: "12px",
    fontWeight: 700,
  },
  legendDot: {
    display: "inline-block",
    width: "10px",
    height: "10px",
    borderRadius: "50%",
    background: "#2563eb",
  },
  hourlyPanel: {
    marginTop: "18px",
    marginBottom: "18px",
    padding: "18px",
    background: "#ffffff",
    border: "1px solid #e5e7eb",
    borderRadius: "14px",
  },
  hourlyHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    gap: "14px",
    flexWrap: "wrap",
    marginBottom: "14px",
  },
  hourlyPeak: {
    padding: "10px 12px",
    borderRadius: "10px",
    background: "#f5f3ff",
    border: "1px solid #ddd6fe",
    display: "flex",
    flexDirection: "column",
    gap: "3px",
  },
  hourlyPeakValue: {
    color: "#5b21b6",
    fontSize: "14px",
  },
  legendDotHourly: {
    display: "inline-block",
    width: "10px",
    height: "10px",
    borderRadius: "50%",
    background: "#7c3aed",
  },
  periodPanel: {
    marginTop: "18px",
    marginBottom: "18px",
    padding: "18px",
    border: "1px solid #e5e7eb",
    borderRadius: "14px",
    background: "#f9fafb",
  },
  periodHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "12px",
    marginBottom: "14px",
  },
  periodTitle: {
    margin: "4px 0 0",
    fontSize: "18px",
    color: "#111827",
  },
  modificationInfo: {
    display: "flex",
    flexWrap: "wrap",
    gap: "10px 22px",
    marginTop: "14px",
    paddingTop: "12px",
    borderTop: "1px solid #e5e7eb",
    color: "#4b5563",
    fontSize: "13px",
  },
  searchBox: {
    marginTop: "8px",
  },
  input: {
    width: "100%",
    boxSizing: "border-box",
    padding: "11px 13px",
    border: "1px solid #d1d5db",
    borderRadius: "9px",
    fontSize: "14px",
  },
  tableContainer: {
    background: "#ffffff",
    borderRadius: "16px",
    padding: "20px",
    marginBottom: "22px",
    boxShadow: "0 4px 18px rgba(0,0,0,0.06)",
  },
  tableTitleRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    gap: "12px",
    flexWrap: "wrap",
    marginBottom: "15px",
  },
  tableMeta: {
    display: "flex",
    flexWrap: "wrap",
    gap: "7px 12px",
    marginTop: "7px",
    color: "#6b7280",
    fontSize: "12px",
  },
  cardsSmall: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(140px, 1fr))",
    gap: "10px",
    marginBottom: "15px",
  },
  miniCard: {
    padding: "12px",
    borderRadius: "10px",
    background: "#f9fafb",
    border: "1px solid #e5e7eb",
  },
  miniLabel: {
    display: "block",
    color: "#6b7280",
    fontSize: "12px",
    marginBottom: "4px",
  },
  miniNumber: {
    color: "#111827",
    fontSize: "20px",
  },
  tableWrapper: {
    width: "100%",
    overflowX: "auto",
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
  },
  th: {
    textAlign: "left",
    padding: "11px",
    borderBottom: "2px solid #e5e7eb",
    background: "#f9fafb",
    color: "#374151",
    fontSize: "13px",
  },
  td: {
    padding: "11px",
    borderBottom: "1px solid #e5e7eb",
    color: "#374151",
    fontSize: "14px",
  },
  tdNombre: {
    padding: "11px",
    borderBottom: "1px solid #e5e7eb",
    color: "#111827",
    fontWeight: 600,
    fontSize: "14px",
    wordBreak: "break-word",
  },
  tdTotal: {
    padding: "11px",
    borderBottom: "1px solid #e5e7eb",
    color: "#111827",
    fontWeight: 800,
    fontSize: "14px",
  },
  empty: {
    padding: "20px",
    textAlign: "center",
    background: "#ffffff",
    borderRadius: "12px",
    color: "#6b7280",
  },
};
export default VeoDatos;
